"use client";
import React, {useState} from 'react';
import styles from './StatucSection.module.css';
import icStatusLine from "../assets/icon/ic_status_line.svg";
import icWallet from "../assets/icon/ic_wallet.svg";
import {useTranslation} from "react-i18next";
import icNav from "../assets/icon/ic_nav.svg";

const StatusSection: React.FC = () => {
    const [walletAddress, setWalletAddress] = useState('');
    const [status, setStatus] = useState('');
    const [statusLink, setStatusLink] = useState<null | string>(null);
    const [err, setErr] = useState('');
    const {t} = useTranslation();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            if (walletAddress.length < 38) {
                setErr(t('statusValid'));
                return;
            } else {
                setErr('');
            }

            setStatus('Loading ...');
            setStatusLink(null);

            const response = await fetch(`https://testnet-api.haven1.org/rewards/status/satoshi/registered?address=${walletAddress}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            console.log('data ', data);
            if (data["message"] === "REGISTERED_NO_KYC") {
                setStatus('Oops! You’re registered but haven’t completed KYC.');
                setStatusLink('Finish it to secure your airdrop!')
            } else if (data["message"] === "NOT_REGISTERED") {
                setStatus('It looks like you’re not registered.');
                setStatusLink('Complete your tasks to secure your airdrop!')
            } else if (data["message"] === "REGISTERED") {
                setStatus('Congratulations, you are all good!');
            }
        } catch (error) {
            setStatus((error as Error).message ?? '');
        }
    };

    return (
        <section className={styles.statusSection}>
            <div className={styles.content}>
                <div className={styles.imageContainer}>
                    <div className={styles.imageWrapper}>
                        <img
                            src={icStatusLine}
                            className={styles.airdropImage}/>
                    </div>
                </div>
                <h2 className={styles.statusCheckTitle}>
                    Unsure if you’re eligible for the airdrop?
                </h2>
                <form onSubmit={handleSubmit} className={styles.formContainer}>
                    <div className={styles.inputField}>
                        <label htmlFor="walletAddress"
                               className={styles.visuallyHidden}>{t('statusEnterWallet')}</label>
                        <div className={styles.inputWrapper}>
                            <img src={icWallet} alt="" className={styles.inputIcon}/>
                            <input
                                type="text"
                                autoComplete="off"
                                id="walletAddress"
                                value={walletAddress}
                                onChange={(e) => setWalletAddress(e.target.value)}
                                placeholder={t('statusEnterWallet')}
                                className={styles.inputPlaceholder}
                            />
                        </div>
                    </div>
                    <div className={styles.buttonContainer}>
                        <button type="submit" className={styles.subscribeButton}>
                            <span className={styles.buttonText}>{t('statusCheck')}</span>
                        </button>
                        <div className={styles.statuses}>
                            {status && (
                                <span className={styles.statusText}>{status}</span>
                            )}
                            {statusLink && (
                                <div className={styles.readFull}
                                     onClick={() => {
                                         window.open('https://testnet.haven1.org/satoshiapp', '_blank');
                                     }}>
                                    <span className={styles.readFullText}>{statusLink}</span>
                                    <img
                                        src={icNav}
                                        className={styles.readFullIcon}
                                    />
                                </div>
                            )}
                        </div>
                        {err && (
                            <p className={styles.errText}>{err}</p>
                        )}
                    </div>
                </form>
            </div>
        </section>
    )
        ;
};

export default StatusSection;